import { createRoot } from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import Popup from '../../components/Map/Popup';
import PopupCarousel from '../../components/Map/PopupCarousel';
import s from '../../components/Map/Map.module.scss';

export const createPopup = (map, coordinates, content) => {
    const el = document.createElement('div');
    const root = createRoot(el);
    root.render(content);

    return new mapboxgl.Popup({
        className: s.PopupWrapper,
        offset: 25,
    })
        .setLngLat(coordinates)
        .setDOMContent(el)
        .addTo(map);
};

export const createClusterPopup = (
    map,
    coordinates,
    allProperties,
    showAddressMissing
) => {
    return createPopup(
        map,
        coordinates,
        <PopupCarousel items={allProperties} showTag={showAddressMissing} />
    );
};

export const createPointPopup = (map, coordinates, properties) => {
    const showAddressMissing = ['city', 'country'].includes(
        properties.coordinateLevel
    );
    const tagTextKey =
        properties.coordinateLevel === 'country'
            ? 'map.tagTextCountry'
            : 'map.tagText';
    return createPopup(
        map,
        coordinates,
        <Popup
            label={properties.category}
            title={properties.name}
            description={properties.fullAddress || properties.address}
            icon={properties.category}
            url={properties.url}
            showTag={showAddressMissing}
            tagTextKey={tagTextKey}
        />
    );
};
